export default __webpack_public_path__ + "static/media/icon-liquid-expose.29f4c9fe.svg";